<template>
  <div class="oauth-callback">
    <LoadingBounce></LoadingBounce>

    <b-modal id="basic-error-alert"
             class="basic-modal no-header-modal hide-cancel-btn"
             v-bind:hide-header="true"
             v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.basic_error_alert.message')"></div>
    </b-modal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import locales from '@/mixins/locales';

  export default {
    name: 'oauth-callback',

    mixins: [
      locales,
    ],

    methods: {
      ...mapActions([
        'setToken',
        'signIn',
      ]),

      getUrlParams() {
        const params = {};
        this.$route.hash.slice(1).split('&').forEach((query) => {
          const [key, value] = query.split('=');

          params[key] = value;
        });

        return params;
      },
    },

    created() {
      const urlParams = this.getUrlParams();
      const token = urlParams.access_token;
      const continueUrl = urlParams.continue_url || sessionStorage.getItem('continue_url');

      if (!token) {
        // TODO: handle error case
        console.error('no token found in URL');
        return 'something';
      }

      return this.setToken(token)
        .then(() => (
          this.signIn()
        ))
        .then((userInfo) => {
          this.$i18n.locale = this.getLocale(userInfo);
        })
        .then(() => {
          if (continueUrl) {
            this.$router.replace(window.decodeURIComponent(continueUrl));
          } else {
            this.$router.replace('/');
          }

          return Promise.resolve();
        })
        .catch((err) => {
          console.error('err while signing in:', err);
          this.$root.$emit('show::modal', 'basic-error-alert');
          return Promise.reject(err);
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/auth/views/OAuthCallback.vue